import { render, staticRenderFns } from "./DerbyRaceInfo.vue?vue&type=template&id=58c72a5e&"
import script from "./DerbyRaceInfo.vue?vue&type=script&lang=js&"
export * from "./DerbyRaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports